/**
 * This file was autogenerated by aem-types-generator.
 * Do not edit manually.
 */

export const ButtonActionItems = {
    UwmModuleOpenMetricDetail: 'UWM_MODULE_OPEN_METRIC_DETAIL',
    UwmModuleNavigateToTips: 'UWM_MODULE_NAVIGATE_TO_TIPS',
    UwmModuleNavigateToDeviceSettings: 'UWM_MODULE_NAVIGATE_TO_DEVICE_SETTINGS',
} as const;

export type ButtonAction = (typeof ButtonActionItems)[keyof typeof ButtonActionItems];

export const ButtonTipsGroupItems = {
    NoConnection: 'NO_CONNECTION',
    WiFiOff: 'WI_FI_OFF',
    ConsumingAnExperience: 'CONSUMING_AN_EXPERIENCE',
    HeatingSelection: 'HEATING_SELECTION',
    NavigatingTheMenu: 'NAVIGATING_THE_MENU',
    PausingAnExperience: 'PAUSING_AN_EXPERIENCE',
    ChangingTheBrightness: 'CHANGING_THE_BRIGHTNESS',
    ManuallyStartingAnExperience: 'MANUALLY_STARTING_AN_EXPERIENCE',
} as const;

export type ButtonTipsGroupType = (typeof ButtonTipsGroupItems)[keyof typeof ButtonTipsGroupItems];

export const ButtonDeviceSettingItems = {
    Tuning: 'TUNING',
    RememberProfile: 'REMEMBER_PROFILE',
    RangeMode: 'RANGE_MODE',
    AutoStart: 'AUTO_START',
    Vibrations: 'VIBRATIONS',
} as const;

export type ButtonDeviceSettingType = (typeof ButtonDeviceSettingItems)[keyof typeof ButtonDeviceSettingItems];

export interface ButtonModel {
    text?: string;
    alt?: string;
    action?: ButtonAction;
    trackingValue?: string;
    tipsGroupType?: ButtonTipsGroupType;
    deviceSettingType?: ButtonDeviceSettingType;
}
